/**
 * Writing Styles - Japanese Localization
 */

export default {
    writingStyles: {
        title: '執筆スタイル',
        description: '特許執筆スタイルを管理',

        // Actions
        actions: {
            create: 'スタイルを作成',
            edit: '編集',
            delete: '削除',
            preview: 'プレビュー',
            duplicate: '複製',
            share: '共有',
            export: 'エクスポート',
            favorite: 'お気に入りに追加',
            unfavorite: 'お気に入りから削除',
            selectFile: 'ファイルを選択',
            uploadFile: 'ファイルをアップロード',
            download: 'ダウンロード',
            cancel: 'キャンセル',
            save: '保存',
            saving: '保存中...',
            confirm: '確認',
            viewAll: 'すべて表示',
            collapseAll: 'すべて折りたたむ',
            expandAll: 'すべて展開',
            sort: '並べ替え',
            more: 'その他',
        },

        // Sort Options
        sort: {
            createdDesc: '作成日（新しい順）',
            updatedDesc: '更新日（新しい順）',
            nameAsc: '名前 (A-Z)',
            usageDesc: '使用回数（多い順）',
        },

        // Tabs
        tabs: {
            all: 'すべて',
            public: '公開',
            private: 'プライベート',
            favorites: 'お気に入り',
        },

        // Filters
        filters: {
            region: '地域',
            allRegions: 'すべての地域',
            sourceType: 'ソースタイプ',
            allSources: 'すべてのソース',
            search: 'スタイルを検索...',
        },

        // View Modes
        viewMode: {
            grid: 'グリッド表示',
            list: 'リスト表示',
        },

        // Categories
        categories: {
            all: 'すべてのカテゴリ',
            public: '公開',
            private: 'プライベート',
            system: 'システムプリセット',
            custom: 'カスタム',
            SYSTEM: 'システムプリセット',
            CUSTOM: 'カスタム',
            favorites: 'お気に入り',
            FAVORITES: 'お気に入り',
            shared: '共有スタイル',
            SHARED: '共有スタイル',
        },

        // Source Types
        sourceTypes: {
            reference: '特許・文書から',
            upload: 'ファイルアップロード',
            manual: '手動入力',
            pdf: 'PDF アップロード',
            word: 'Word アップロード',
            patent_number: '特許番号',
            patentNumber: '特許番号',
        },

        // Regions
        regions: {
            all: 'すべての地域',
            USPTO: 'アメリカ',
            us: 'アメリカ',
            CNIPA: '中国',
            cn: '中国',
            EPO: 'ヨーロッパ',
            ep: 'ヨーロッパ',
            JPO: '日本',
            jp: '日本',
            KIPO: '韓国',
            kr: '韓国',
            WIPO: 'WIPO',
            wipo: 'WIPO',
            PCT: '国際 (PCT)',
        },

        // Sections
        sections: {
            title: 'タイトル',
            titlePlaceholder: '特許タイトルを入力',
            abstract: '要約',
            abstractPlaceholder: '特許要約を入力',
            background: '背景技術',
            backgroundPlaceholder: '背景技術を入力',
            summary: '発明の概要',
            summaryPlaceholder: '発明の概要を入力',
            description: '詳細な説明',
            descriptionPlaceholder: '詳細な説明を入力',
            claims: '請求項',
            claimsPlaceholder: '請求項を入力',
        },

        // Dialog
        dialog: {
            createStyle: '執筆スタイルを作成',
            editStyle: '執筆スタイルを編集',
            createStyleDesc: '公開特許から学び、あなたの執筆スタイルを構築',
            styleName: 'スタイル名',
            styleNamePlaceholder: 'スタイルの説明的な名前を入力',
            description: '説明',
            descriptionPlaceholder: '簡単な説明を入力（オプション）',
            region: '地域',
            category: 'カテゴリ',
            visibility: '可視性',
            public: 'チーム可視',
            private: 'プライベート',
            publicDesc: 'すべてのチームメンバーに表示',
            privateDesc: '自分のみに表示',
            sourceType: 'ソースタイプ',
            manualDesc: '各セクションを手動で入力',
            pdfDesc: 'PDF ファイルをアップロードしてコンテンツを抽出',
            wordDesc: 'Word ドキュメントをアップロードしてコンテンツを抽出',
            patentNumberDesc: '特許番号からコンテンツを取得',
            uploadFile: '参考文書',
            dragDropOrClick: 'ファイルをクリックまたはドラッグしてアップロード',
            pdfWordSupport: 'PDF と Word ドキュメント対応（最大 50MB）',
            pdfOnly: 'PDF ファイルのみ対応（最大 50MB）',
            wordOnly: 'Word ドキュメントのみ対応（最大 50MB）',
            selectFile: 'ファイルを選択',
            uploading: 'アップロード中...',
            patentNumber: '参照特許',
            patentNumberPlaceholder: '例：US1234567A、CN201910123456A',
            fetch: '取得',
            sections: '特許セクション',
            sectionsHint: '各セクションの内容を設定',
            expandAll: 'すべて展開',
            collapseAll: 'すべて折りたたむ',
            sectionPlaceholder: 'このセクションの内容を入力...',
            required: '必須',
            chars: '文字',
            cancel: 'キャンセル',
            create: 'スタイルを作成',
            save: '変更を保存',
            saveChanges: '変更を保存',
            saving: '保存中...',

            // Selected sources summary
            selectedPatentsCount: '{count}/{max} 件の特許を選択済み',
            selectedFilesCount: '{count} 件のファイル',
            unsavedChangesTitle: '未保存の変更',
            unsavedChangesMessage: '未保存の変更があります。閉じてもよろしいですか？変更内容は失われます。',
            discardChanges: '変更を破棄',
            continueEditing: '編集を続ける',
            styleCreated: 'スタイル作成済み',
            styleCreatedSuccess: 'スタイルが正常に作成されました。ダイアログを閉じてリストで確認できます。',
            minPatentsRequired: '最低2件の特許が必要です',
            maxPatentsExceeded: '特許数の上限を超えています',
            minFilesRequired: '最低2件のファイルが必要です',
            maxFilesExceeded: 'ファイル数の上限を超えています',
            selectPatentsFirst: '先に特許を選択してください',
            patentLimitReached: '特許数の上限に達しました（5件）',

            // Visibility Dialog
            changeVisibility: '可視性権限を変更',
            visibilityDescription: 'この執筆スタイルの可視性設定を選択してください。プライベートスタイルは自分のみに表示され、公開スタイルはチーム全員に表示されます。',
            teamVisible: 'チーム可視',
            teamVisibleDesc: 'チーム全員に表示',
            privateVisible: 'プライベート',
            privateVisibleDesc: '作成者のみに表示',
            changeToPublicWarning: 'チーム可視に変更すると、チームの全メンバーがこのスタイルを表示・使用できるようになります。',
            changeToPrivateWarning: 'プライベートに変更すると、自分のみがこのスタイルを表示・使用できるようになります。',

            // Read-only permission
            readOnlyPermission: '読み取り専用権限',
            readOnlyPermissionDesc: 'このスタイルは閲覧のみ可能で、編集や保存はできません',

            // Level selection (Super Admin only)
            level: '可視性',
            adminOnly: '管理者のみ',
            systemLevel: 'システムレベル',
            userLevel: 'ユーザーレベル',
            systemLevelDesc: 'すべてのユーザーに表示',
            userLevelDesc: '自分のみ表示',
        },

        // Create Dialog (legacy - for backward compatibility)
        createDialog: {
            title: '執筆スタイルを作成',
            editTitle: '執筆スタイルを編集',
            basicInfo: '基本情報',
            name: '名前',
            namePlaceholder: 'スタイル名を入力',
            nameRequired: '名前は必須です',
            description: '説明',
            descriptionPlaceholder: 'スタイルの説明を入力（オプション）',
            region: '地域',
            regionPlaceholder: '地域を選択',
            regionRequired: '地域は必須です',
            category: 'カテゴリ',
            categoryPlaceholder: 'カテゴリを選択',
            tags: 'タグ',
            tagsPlaceholder: 'タグを追加（Enter キーを押す）',

            sourceMethod: 'ソース方法',
            selectSourceMethod: 'スタイルを作成する方法を選択',
            manualInput: '手動入力',
            manualInputDesc: '各セクションの内容を手動で入力',
            uploadPdf: 'PDF アップロード',
            uploadPdfDesc: 'PDF ファイルをアップロードしてコンテンツを抽出',
            uploadWord: 'Word アップロード',
            uploadWordDesc: 'Word ドキュメントをアップロードしてコンテンツを抽出',
            patentNumber: '特許番号',
            patentNumberDesc: '特許番号からコンテンツを取得',

            patentNumberLabel: '特許番号',
            patentNumberPlaceholder: '特許番号を入力（例：US1234567A）',
            patentNumberFetch: '特許を取得',
            patentNumberFetching: '取得中...',

            fileUpload: 'ファイルアップロード',
            fileUploadDrag: 'ファイルをクリックまたはドラッグしてアップロード',
            fileUploadHint: 'PDF および Word ファイルに対応、最大 50MB',
            fileUploading: 'アップロード中...',
            fileProcessing: 'ファイル処理中...',
            fileProcessed: 'ファイル処理が完了しました',

            sectionContent: 'セクションコンテンツ',
            sectionContentDesc: '各セクションのコンテンツを編集',
            sectionRequired: '必須',
            sectionOptional: 'オプション',
            sectionPlaceholder: '{section} の内容を入力',
            sectionEmpty: 'コンテンツなし',
        },

        // Preview Dialog
        preview: {
            title: '執筆スタイルをプレビュー',
            loading: 'プレビューを読み込んでいます...',
            wordDocument: 'Word ドキュメント',
            patentNumber: '特許番号',
            noContent: 'コンテンツがありません',
            resetZoom: 'ズームをリセット',
            sections: 'セクション',
            usageCount: '使用回数',
            lastUpdated: '最終更新',
        },
        previewDialog: {
            title: '執筆スタイルをプレビュー',
            loading: 'プレビューを読み込んでいます...',
            sourceInfo: 'ソース情報',
            sourceType: 'ソースタイプ',
            fileName: 'ファイル名',
            patentNumber: '特許番号',
            fileSize: 'ファイルサイズ',
            uploadDate: 'アップロード日',
            openFile: 'ファイルを開く',
            sections: 'セクション',
        },

        // Empty States
        empty: {
            noStyles: '執筆スタイルがありません',
            createFirstStyle: '最初の執筆スタイルを作成して始めましょう',
            noResults: 'スタイルが見つかりません',
            tryDifferentFilters: 'フィルターまたは検索条件を調整してみてください',
            noStylesFound: '執筆スタイルが見つかりません',
        },
        emptyState: {
            title: '執筆スタイルがありません',
            description: '最初の執筆スタイルを作成して始めましょう',
            createButton: 'スタイルを作成',
            noResults: 'スタイルが見つかりません',
            noResultsDesc: 'フィルターまたは検索条件を調整してみてください',
        },

        // Stats
        stats: {
            total: '総スタイル数',
            public: '公開スタイル',
            private: 'プライベートスタイル',
            system: 'システムスタイル', // ✅ 追加
            custom: 'カスタムスタイル', // ✅ 追加
            favorites: 'お気に入りスタイル',
        },

        // Delete Confirmation
        delete: {
            title: '執筆スタイルを削除',
            message: '"{name}" を削除してもよろしいですか？',
            confirm: '削除',
            cancel: 'キャンセル',
        },

        // Editor
        editor: {
            createTitle: '執筆スタイルを作成',
            editTitle: '執筆スタイルを編集',
            basicInfo: '基本情報',
            sourceType: 'ソースタイプ',
            referenceDoc: '参考文書',
            manualInput: '手動入力',
            patentNumber: '特許番号',
            patentNumberPlaceholder: '例：US1234567A、CN201910123456A',
            fetch: '取得',
            uploadFile: 'ファイルをアップロード',
            uploadTitle: '特許文書をクリックまたはドラッグしてアップロード',
            uploadHint: '特許文書を執筆スタイルの参考としてアップロード — PDF・Word 対応（最大 50MB）',
            fileProcessing: '処理中...',
            fileCompleted: '完了',
            fileFailed: '失敗',
            loadingPatentData: '特許情報を読み込んでいます...',
            patentDataLoaded: '特許情報が読み込まれました',
            searchFailed: '検索に失敗しました',
            patentDataLoadSuccess: '特許情報が読み込まれました',
            patentDataLoadFailed: '特許情報の読み込みに失敗しました',
            fileUploadedHint: 'ファイルがアップロードされました。特許番号は入力できません',
            patentNumberEnteredHint: '特許番号が入力されました。ファイルはアップロードできません',
            generateStyle: 'スタイルを生成',
            generateSuccess: 'スタイルが生成されました',
            generateFailed: 'スタイルの生成に失敗しました',
            manualEditMode: '手動編集モードに入りました',
            manualInputHint: '手動入力を選択後、右側のエディターでスタイル内容を直接編集できます',
            emptyTitle: '執筆スタイルの作成を開始',
            emptyDescription: '左側の基本情報を入力し、参考文書または手動入力を選択してから、「スタイルを生成」ボタンをクリックしてください',
            sectionsTitle: '執筆スタイルの内容を編集',
            sectionsHint: '各セクションの内容を入力してください。必須とマークされたセクションは入力必須です。',
            previewTitle: 'スタイル内容のプレビュー',
            patentTitle: 'タイトル',
            patentAbstract: '要約',
            patentClaims: '請求項',
            patentDescription: '説明',
            autoCreate: '分析して作成',
        },

        // Messages
        messages: {
            createSuccess: '執筆スタイルが作成されました',
            createError: '執筆スタイルの作成に失敗しました',
            updateSuccess: '執筆スタイルが更新されました',
            updateError: '執筆スタイルの更新に失敗しました',
            saveError: '執筆スタイルの保存に失敗しました',
            deleteSuccess: '執筆スタイルが削除されました',
            deleteError: '執筆スタイルの削除に失敗しました',
            deleteConfirm: '"{name}" を削除してもよろしいですか？',
            deleteConfirmDesc: 'この操作は元に戻せません',
            favoriteSuccess: 'お気に入りに追加しました',
            unfavoriteSuccess: 'お気に入りから削除しました',
            toggleFavoriteError: 'お気に入りの切り替えに失敗しました',
            duplicateSuccess: '執筆スタイルが複製されました',
            duplicateError: '執筆スタイルの複製に失敗しました',
            fileUploadSuccess: 'ファイルがアップロードされました',
            fileUploadError: 'ファイルのアップロードに失敗しました',
            patentFetchSuccess: '特許情報が取得されました',
            patentFetchError: '特許情報の取得に失敗しました',
            validationError: 'すべての必須項目を入力してください',
            sectionValidationError: 'すべての必須セクションを入力してください',
            fetchDetailFailed: 'スタイル詳細の取得に失敗しました',
            shareSuccess: '共有に成功しました',
            shareFailed: '共有に失敗しました',
            updateShareSuccess: '共有の更新に成功しました',
            updateShareFailed: '共有の更新に失敗しました',
            deleteShareSuccess: '共有の削除に成功しました',
            deleteShareFailed: '共有の削除に失敗しました',
        },

        // Share
        share: {
            title: '執筆スタイルを共有',
            companyShare: '会社',
            companyShareName: '当社',
            personalShare: '個人',
            searchUser: 'メールまたは名前で検索',
            permission: '権限',
            readOnly: '読み取り専用',
            editable: '編集可能',
            expiresAt: '有効期限',
            neverExpires: '無期限',
            expiry7Days: '7日間',
            expiry15Days: '15日間',
            expiry30Days: '30日間',
            companyShareDesc: '会社のすべてのメンバーがこのスタイルにアクセスできます',
            personalShareDesc: '指定されたユーザーのみがこのスタイルにアクセスできます',
            sharedTo: '共有先',
            shareList: '共有済み',
            createShare: '共有を作成',
            cancel: 'キャンセル',
            confirm: '確認',
            deleteShareConfirm: 'この共有記録を削除してもよろしいですか？',
        },

        // Card Info
        card: {
            usedTimes: '{count} 回使用',
            lastModified: '{time} に変更',
            createdBy: '作成者 {name}',
        },

        // Patent Search Dialog
        patentSearch: {
            title: '特許検索',
            placeholder: '特許番号を入力（例：US11739015B2、CN201910123456A）',
            placeholderMultiline: '特許番号を貼り付けまたは入力（1行に1つ、カンマ・セミコロン・スペースで区切りも可）\n例：\nCN222815419U\nCN222619343U\nCN220672152U',
            search: '検索',
            hint: '特許番号で検索 — AI がその執筆パターンを分析してスタイルを構築します',
            hintBatch: '一括検索対応：複数の特許番号をカンマ、セミコロン、スペース、または改行で区切る',
            searching: '検索中...',
            noResults: '関連する特許が見つかりません',
            searchSuccess: '上位{count} 件の関連特許',
            searchFailed: '検索に失敗しました。後でもう一度お試しください',
            batchSearching: '{count} 件の特許を一括検索中...',
            batchSearchSuccess: '一括検索完了：成功 {success} 件、失敗 {failed} 件、合計 {total} 件の特許が見つかりました',
            selectedCount: '{count} 件の特許が選択されています',
            selectAtLeastOne: '少なくとも1つの特許を選択してください',
            loadDetailsFailed: '特許詳細の読み込みに失敗しました',
            enterPatentNumber: '特許番号を入力してください',
            recognizedCount: '{count} 件の特許番号を認識',
            recognizedCountDedup: '{count} 件の特許番号を認識（重複除去済み、元 {original} 件）',
            duplicatesRemoved: '{count} 件の重複を自動除去',
            batchResultTitle: '一括検索結果',
            batchAutoAdded: '{count} 件の特許を自動追加しました',
            notFound: '見つかりません',
            patentAlreadySelected: 'この特許は既に選択済みです',
        },

        // Extraction Progress
        extraction: {
            steps: {
                submitting: '抽出タスクを送信中',
                fetchingData: '特許セクションデータを取得中',
                analyzing: 'AI が執筆スタイルを分析中',
                complete: '抽出完了',
            },
            waitingTime: '経過時間 {time}',
            estimatedTime: '通常1〜2分かかります',
            cancel: 'キャンセル',
            cancelConfirm: '現在の抽出タスクをキャンセルしますか？',
            cancelled: '抽出タスクをキャンセルしました',
            contextPatents: '分析中の特許',
            contextFiles: '分析中のファイル',
            submittingTask: 'スタイル抽出タスクを送信中...',
            fetchingSectionData: '特許セクションデータを取得中...',
            analyzingStyle: 'AIが特許を分析し、執筆スタイルを抽出中...',
            analyzingStyleProcessing: 'AIが特許を分析し、執筆スタイルを抽出中...（処理中）',
        },
    },
};
